import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AlertService } from '../shared/components/app-alert';
import { AADAuthenticationService } from '../shared/services/aadauthentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent {

  constructor(
    private alert: AlertService,
    private authService: AADAuthenticationService,
    private router: Router
  ) { }

  public onSubmit(form: NgForm) {
    this.alert.clear();
    this.authService.login(() => {this.router.navigate(['customers']);});
  }

}